import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { formSettings } from './settings';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../../../../text/messages';
import { CheckboxField, RadioField } from './../../../../../components/fields';
import Document from './../../../../../components/document';
import { PERMISSIONS, CLIENT_DOCTYPES } from './../../../../../components/document/types';
import WizardButtons from '../../../../../components/wizard/navigator/buttons';
import { getAdmin } from '../../../../../reducers/onboarding';
import { updateUserDetails, getUserDetails, submitOnboarding } from '../../../../../reducers/identity';
import { getRequirements } from '../../../../../reducers/tenants';
import { history } from '../../../../../configuration/store';
import { HelpButton } from '../../../../../components/richButtons';

class ProgramPoliciesStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.getBGCheckOptions = this.getBGCheckOptions.bind(this);
    }

    componentDidMount() {
        let { admin, client, getAdmin } = this.props;
        if (!admin) getAdmin(client.admin_id);
    }

    getBGCheckOptions() {
        const { policies } = this.props;
        const { job_policies } = policies;
        const { bg_check_type } = job_policies;

        return [
            {
                value: 'basic',
                label: (
                    <div className="">
                        <i className="material-icons">{bg_check_type === 'basic' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        <FormattedMessage {...messages.basic} tagName={'span'} />
                    </div>
                )
            },
            {
                value: 'enhanced',
                label: (
                    <div className="">
                        <i className="material-icons">{bg_check_type === 'enhanced' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        <FormattedMessage {...messages.enhanced} tagName={'span'} />
                    </div>
                )
            }
        ];
    }

    submit(values) {
        const { role, client, updateUserDetails, getUserDetails, getRequirements, submitOnboarding } = this.props;

        updateUserDetails(role, { ...client, job_policies: values.job_policies }, () => {
            submitOnboarding(client, role, () => {
                getUserDetails(role, () => {
                    getRequirements(role, () => history.push('/'));
                });
            });
        });
    }
    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, client, policies } = this.props;
        const { job_policies } = policies;
        const { bg_check, drug_check, individual_po, w2_only, ic_only, ic_waive_insurance } = job_policies;

        if (!admin) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'clientOnboarding.programPoliciesIntroText1'}
                            defaultMessage={
                                "We'll ask some questions about your company and policies, which will carry throughout all the jobs added in the future. This information can be changed."
                            }
                        />
                    </div>
                </div>

                <div className="row section onboarding-box">
                    <div className="col-xs-12">
                        <FormattedMessage id={'clientOnboarding.backgroundCheck'} defaultMessage={'Background Check'} tagName={'h5'} />
                        <Field
                            name="job_policies.bg_check"
                            component={CheckboxField}
                            checked={bg_check === true}
                            placeholder={{ ...messages.clientRequiresBackgroundCheck, values: { client: client.name } }}
                            hideErrors
                        />
                    </div>
                    {bg_check === true && (
                        <div className="col-xs-12 bg-check-type-choice">
                            <Field
                                name="job_policies.bg_check_type"
                                component={RadioField}
                                options={this.getBGCheckOptions()}
                                placeholder={{ ...messages.backgroundCheckType }}
                                hideErrors
                            />
                            <ul>
                                <FormattedHTMLMessage
                                    id={'clientOnboarding.companyPolicyDocuments'}
                                    defaultMessage={
                                        '<li>National Criminal Search (standard)</li><li>County Criminal Search - last 7 years</li><li>Sex Offender Search</li><li>SSN Trace</li><li>Global Watchlist Search</li>'
                                    }
                                    tagName={'div'}
                                />
                                {job_policies.bg_check_type === 'enhanced' && (
                                    <FormattedHTMLMessage
                                        id={'clientOnboarding.companyPolicyDocuments'}
                                        defaultMessage={'<li>+ Employment Verification (current position)</li><li>+ Education Verification</li>'}
                                        tagName={'div'}
                                    />
                                )}
                            </ul>
                        </div>
                    )}
                    <div className="col-xs-12">
                        <Field
                            name="job_policies.drug_check"
                            component={CheckboxField}
                            checked={drug_check === true}
                            placeholder={{ ...messages.clientRequiresDrugCheck, values: { client: client.name } }}
                            hideErrors
                        />
                    </div>
                    <div className="col-xs-12">
                        <Field
                            name="job_policies.individual_po"
                            component={CheckboxField}
                            checked={individual_po === true}
                            placeholder={{ ...messages.clientRequiresIndividualPO }}
                            hideErrors
                        />
                    </div>
                </div>
                <div className="row section onboarding-box">
                    <div className="col-xs-12">
                        <HelpButton
                            text={
                                <FormattedHTMLMessage
                                    {...messages.companyPolicyDocumentsExplanation}
                                    values={{ admin: admin.name, client: client.name }}
                                    tagName={'p'}
                                />
                            }
                        />
                        <FormattedMessage id={'clientOnboarding.companyPolicyDocuments'} defaultMessage={'Company Policy Documents'} tagName={'h5'} />
                        <FormattedHTMLMessage
                            {...messages.companyPolicyDocumentsExplanation}
                            values={{ admin: admin.name, client: client.name }}
                            tagName={'p'}
                        />

                        <Document
                            id={'clientOnboardingNDA'}
                            docType={CLIENT_DOCTYPES.NDA}
                            displayName="Nondisclosure Agreement (NDA)"
                            upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                            view={{ showHeader: false }}
                        />
                        <Document
                            id={'clientPIIA'}
                            docType={'clientPIIA'}
                            displayName="Proprietary Information / Inventions Agreement"
                            upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                            view={{ showHeader: false }}
                        />
                        <Document
                            id={'clientOnboardingTraining'}
                            docType={'clientOrientationTraining'}
                            displayName="Orientation and Training Manual"
                            upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                            view={{ showHeader: false }}
                        />
                        <Document
                            id={'clientExtraDoc1'}
                            docType={'clientExtraDoc1'}
                            displayName="Other"
                            upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                            view={{ showHeader: false }}
                        />
                        <Document
                            id={'clientExtraDoc2'}
                            docType={'clientExtraDoc2'}
                            displayName="Other"
                            upload={{ limit: 1, permissions: PERMISSIONS.CLIENT_UPLOAD }}
                            view={{ showHeader: false }}
                        />
                    </div>
                </div>
                <div className="row section onboarding-box">
                    <div className="col-xs-12">
                        <FormattedMessage {...messages.workerClassification} tagName={'h5'} />
                        <FormattedHTMLMessage {...messages.clientW2ICexplanation} tagName={'p'} />
                        <Field
                            name="job_policies.w2_only"
                            component={CheckboxField}
                            checked={w2_only === true}
                            placeholder={{ ...messages.clientW2Only, values: { client: client.name } }}
                            hideErrors
                            onChange={(_, newValue) => {
                                if (newValue) {
                                    job_policies.ic_only = false;
                                }
                            }}
                        />
                        <Field
                            name="job_policies.ic_only"
                            component={CheckboxField}
                            checked={ic_only === true}
                            placeholder={{ ...messages.clientICOnly, values: { client: client.name } }}
                            hideErrors
                            onChange={(_, newValue) => {
                                if (newValue) {
                                    job_policies.w2_only = false;
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row onboarding-box">
                    <div className="col-xs-12">
                        <FormattedMessage id={'clientOnboarding.ICInsurance'} defaultMessage={'Independent Contractor Insurance'} tagName={'h5'} />
                        <FormattedHTMLMessage {...messages.clientAllowsICExplanation} values={{ admin: admin.name, client: client.name }} tagName={'div'} />
                    </div>
                    <div className="col-xs-12">
                        <Field
                            name="job_policies.ic_waive_insurance"
                            component={CheckboxField}
                            checked={ic_waive_insurance === true}
                            placeholder={{ ...messages.icWaiveInsurance }}
                            hideErrors
                        />
                    </div>
                </div>

                <WizardButtons id={{ id: 'onboarding-policies-continue' }} disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

ProgramPoliciesStep = reduxForm(formSettings)(ProgramPoliciesStep);
const selector = formValueSelector('client-onboarding-wizard');
const mapStateToProps = state => {
    let defaultValue = {
        job_policies: {
            bg_check: false,
            bg_check_type: 'basic',
            drug_check: false,
            individual_po: false,
            w2_only: false,
            ic_only: false,
            ic_waive_insurance: false
        }
    };
    let client = state.identity.details;
    return {
        role: state.identity.role,
        client,
        admin: state.onboarding.admin,
        policies: selector(state, 'job_policies') ? { job_policies: selector(state, 'job_policies') } : defaultValue,
        initialValues: client.job_policies ? { job_policies: client.job_policies } : defaultValue
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            updateUserDetails: updateUserDetails,
            submitOnboarding: submitOnboarding,
            getUserDetails: getUserDetails,
            getRequirements: getRequirements
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ProgramPoliciesStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/client/steps/programPolicies.jsx